
import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'

@Component({
  name: 'DashboardScholarshipIssueModal',
  components: {
    CloseCrossCtrl,
    DashboardButton,
    Icon
  }
})
export default class DashboardScholarshipIssueModal extends Vue {
  @Prop({ type: Number, required: true }) scholarshipId!: number

  img = require('./issue-modal/woman-oppresses-shapes.svg?inline').default

  close() {
    this.$emit('close')
    window.location.href = this.$route.fullPath
  }
}
